import api from "../../utils/ApiConfig";

export const fetchPartners = async () => {
  const response = await api.get("/bo/partners");
  return response.data;
};

export const createPartner = async (data) => {
  const response = await api.post("/bo/partners", data);
  return response.data;
};

export const updatePartner = async (id, data) => {
  const response = await api.put(`/bo/partners/${id}`, data);
  return response.data;
};

export const regenerateToken = async (id) => {
  const response = await api.post(`/bo/partners/${id}/regenerate-token`);
  return response.data;
};
